
import List from "./components/List.vue";
import {
  buildBreadcrumbJsonLd,
  buildPageJsonLd,
  flatTreeData,
  findParentElements,
  getBreadList,
  getSiteOrigin,
} from "~/utils/index.js";
export default {
  asyncData({ app, route, store }) {
    const db = app.$websiteDataHelper;
    const pageBannerbg =
      encodeURI(db.getMenuItemBanner("news")) ||
      "/img/knowledge-page-banner.png";
    const routeId = route.meta[0].nodeid;

    const categories = store.state.menu.filter(
      item => item.path === "/products",
    )[0].children;
    const hotProducts = db.hotProducts.slice(0, 3);

    const pageSize = 12;
    const currentPage = route.meta[0].page || 1;
    const { list = [], count = 0 } = app.$websiteDataHelper.getList(
      "news",
      routeId,
      currentPage,
      pageSize,
    );

    const menus = store.state.menu.filter(m => m.type === "news");
    const currentPath = route.path.split("/")[1];
    const currentVO = app.$websiteDataHelper.getCurrentVO(
      menus,
      `/${currentPath}`,
    );

    const flatArray = flatTreeData(menus);
    const breadList = findParentElements(routeId, flatArray);
    return {
      banner: pageBannerbg,
      title: (currentVO?.name_ch || "news").toUpperCase().replace(/-/g, " "),
      menu: categories,
      total: count,
      hotProducts,
      currentPage,
      pageData: list,
      pageSize,
      customList: breadList,
      currentVO,
    };
  },
  head() {
    const { meta } = this.$route;
    const { menu, baseInfo, footerData } = this.$store.state;
    const siteUrl = getSiteOrigin();
    const breadList = getBreadList(menu, this.currentVO, 1);

    return {
      script: [
        {
          type: "application/ld+json",
          json: [
            buildPageJsonLd({
              route: this.$route,
              meta,
              siteUrl,
              baseInfo,
              footerData,
              includePublisher: true,
            }),
            buildBreadcrumbJsonLd(breadList),
          ],
        },
      ],
    };
  },
  components: { List },
};
